import React, { Component, Fragment } from 'react'
import List from './List'
import TransactionModal from './Modals/TransactionModal'
import MapStatementModal from './Modals/MapStatementModal'
import StatementModal from '../StatementModal'
import TransactionUploadModal from '../../../../components/Finance/Statements/Transactions/Modals/TransactionUploadModal'

class Transactions extends Component {
  render() {
    const { visibleStatement, onCancelStatement, formAllocateRef, ...rest } = this.props
    return (
      <Fragment>
        <TransactionModal key={'transaction-modal'} {...this.props} />
        <MapStatementModal key={'map-statement-modal'} {...this.props} />
        <TransactionUploadModal key={'transaction-upload-modal'} {...this.props} />
        <StatementModal
          {...rest}
          key={'statement-modal'}
          visible={visibleStatement}
          onCancel={onCancelStatement}
          type={'edit'}
        />
        <List {...this.props} />
      </Fragment>
    )
  }
}

Transactions.propTypes = {}
Transactions.defaultProps = {}

export default Transactions
